import { Stack } from 'expo-router';

import { BASE_STACK_SCREEN_OPTIONS } from '@/constants/screenOptions';

/**
 * The public sections on native. Only a signed-out web visitor is sent to these public twins (a
 * fresh load of a section's path resolves to the secure tab), so native reaches them at most
 * through a stray link, where they stack like any other open screen. Web shows them as tabs; see
 * `_layout.web.tsx`.
 */
export default function OpenSectionsLayout() {
  return <Stack screenOptions={BASE_STACK_SCREEN_OPTIONS} />;
}
